import { useState } from "react";
import { AssetsHttpService } from "@/shared/services/assets/assets-http.service";

export function useUploadClientLogoHook(
  defaultImageUrl: string,
  onUpload: (data: string) => void,
  clientId: string,
  onRemove?: () => void,
) {
  const [imageUrl, setImageUrl] = useState<string>(defaultImageUrl ? defaultImageUrl : "");
  const [isLoading, setIsLoading] = useState(false);
  const [photoError, setPhotoError] = useState(false);

  const uploadFile = async (options: any) => {
    const { onSuccess, onError, file } = options;

    const formData = new FormData();

    formData.append("file", file);

    try {
      setIsLoading(true);

      const res = await AssetsHttpService.uploadClientLogo(formData, Number(clientId));

      onSuccess("Ok");

      // TODO: Create Http statuses enum
      if (res.status === 201) {
        setImageUrl(res.data.secure_url);
        onUpload(res.data.secure_url);
        setPhotoError(false);
        setIsLoading(false);
      } else {
        setPhotoError(true);
        setIsLoading(false);
      }
    } catch (err) {
      onError({ err });
    }
  };

  const removeImage = onRemove
    ? () => {
        setImageUrl("");
        setPhotoError(false);
        onRemove();
      }
    : null;

  return { imageUrl, photoError, isLoading, uploadFile, removeImage };
}
